import { render, staticRenderFns } from "./directInvest_Login.vue?vue&type=template&id=2cc8a1be&scoped=true"
import script from "./directInvest_Login.vue?vue&type=script&lang=js"
export * from "./directInvest_Login.vue?vue&type=script&lang=js"
import style0 from "./directInvest_Login.vue?vue&type=style&index=0&id=2cc8a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8a1be",
  null
  
)

export default component.exports